"use strict";var $isNaN=require("./isNaN");module.exports=function(number){return $isNaN(number)||0===number?number:number<0?-1:1};